module.exports = __webpack_public_path__ + "static/media/stripe-logo.7e58d361.png";